<template>
  <v-btn
    v-if="showedit"
    fab
    width="27"
    height="27"
    color="primary"
    elevation="0"
    class="btn_tippy vuetify--sacnite"
    :class="clase + (loading ? ' loading' : '')"
    :loading="loading"
    :title="$t('view.commons.edit')"
    @click="edit(clave || clavestr || item)">
    <em class="fas fa-pen" />
  </v-btn>
</template>
<script>
export default {
  name: "ButtonEdit"
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , clavestr: {
      default: null
      , type: String
    }
    , item: {
      default: null
      , type: Object
    }
    , showedit: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
  }
  , methods: {
    edit(clave) {
      this.$emit("edit", clave);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonEdit.vue